import { useEffect } from "react";

import * as billPaymentAction from "store/entities/billPayment/action";

import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { renderStatusColor } from "utils/statusColor";
import Filter from "components/__new/common/Filter";
import { ReactComponent as IconAba } from "assets/images/icons/project-icons/billPaymentProviders/power/aba.svg"
import { ReactComponent as IconAbuja } from "assets/images/icons/project-icons/billPaymentProviders/power/abuja.svg"
import { ReactComponent as IconBenin } from "assets/images/icons/project-icons/billPaymentProviders/power/benin.svg"
import { ReactComponent as IconEko } from "assets/images/icons/project-icons/billPaymentProviders/power/eko.svg"
import { ReactComponent as IconEnugu } from "assets/images/icons/project-icons/billPaymentProviders/power/enugu.svg"
import { ReactComponent as IconIbadan } from "assets/images/icons/project-icons/billPaymentProviders/power/ibadan.svg"
import { ReactComponent as IconIkeja } from "assets/images/icons/project-icons/billPaymentProviders/power/ikeja.svg"
import { ReactComponent as IconJos } from "assets/images/icons/project-icons/billPaymentProviders/power/jos.svg"
import { ReactComponent as IconKaduna } from "assets/images/icons/project-icons/billPaymentProviders/power/kaduna.svg"
import { ReactComponent as IconKano } from "assets/images/icons/project-icons/billPaymentProviders/power/kano.svg"
import { ReactComponent as IconPortHC } from "assets/images/icons/project-icons/billPaymentProviders/power/porthc.svg"
import { ReactComponent as IconAdd } from "assets/images/icons/project-icons/Plus.svg"
import { ReactComponent as IconCopy } from "assets/images/icons/project-icons/copy.svg";
import { TableContent } from "components/__new/common/TableContent";
import { DateFormat, TimeFormat } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import ContentLoading from "components/__new/common/ContentLoading";
import { useState } from "react";
import TableEmptyData from "components/__new/common/TableEmptyData";
import pluralize from "utils/pluralize";
import TransactionDetailsWrapper from "components/__new/common/TransactionDetailsWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useTransformedBillers } from "hooks/useTransformedBillers";
import useBillPayments from "hooks/useBillPayments";



export const PowerPurchaseTable = ({togglePurchaseModal, loading, data}) => {
    const dispatch = useDispatch()
    
    const { providers } = useSelector((state) => state.entities.billPayment)
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    
    const ElectricityBillerIcon = useBillPayments()
    
    const electricityData = useTransformedBillers('electricity', providers?.response);
    const openTransactionDetail = (transaction) => {
        setSelected(transaction);
        setDetailsOpen(true);
    }
    
    
    useEffect(() => {
        dispatch(billPaymentAction.getProviders());
        // eslint-disable-next-line
    }, []);
    
    
    const transformDisplay = (data) => {
        return data?.map(item => {
            const transformedDisplay = item.display
                .replace(/_/g, ' ')                  // Replace underscores with spaces
                .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
            return {
                ...item,
                display: transformedDisplay
            };
        });
    };
    
    const transformElectricityData = transformDisplay(electricityData)
    
    return (
        <div>
            
            <TransactionDetails 
                isOpen={detailsOpen}
                transaction={selected}
                setIsOpen={setDetailsOpen}
                ElectricityBillerIcon={ElectricityBillerIcon}
            />
            
            <div className="mt-6 box">
                
                <div className="flex items-center justify-start w-max">
                    <div className="font-medium">Electricity Purchase History&nbsp;</div>
                    
                    <div className="label h-6 text-sm font-normal text-ep-primary-600 bg-[#ecf2f2]">
                        <ContentLoading
                            loading={loading}
                            data={<>{data?.data?.totalDocs ?? "-"} {pluralize(data?.data?.totalDocs, "purchase", "purchases")}</>}
                        />
                    </div>
                </div>
                
                <div className="mt-6 flex flex-wrap justify-between">
                    <div className="max-w-sm flex-grow sm:mr-6">
                        <SearchBox placeholder="Search" name="search" extraUrlParams="page=1" />
                    </div>
                        
                    <div className="flex flex-wrap space-x-3 sm:space-x-5">
                        <div>
                            <Filter filters={[
                                {
                                    title: "Date range",
                                    name: "dateRange",
                                    dataType: "custom-timeframe",
                                    hasResetButton: true,
                                    options: [
                                        {
                                            display: "Today",
                                            payload: "today",
                                        },
                                        {
                                            display: "Last 7 days",
                                            payload: "7days",
                                        },
                                        {
                                            display: "30 days",
                                            payload: "30days",
                                        },
                                        {
                                            display: "1 Year",
                                            payload: "1year",
                                        },
                                    ],
                                },
                                {
                                    title: "Date Range",
                                    dataType: "date-range",
                                    options: {
                                        from: {
                                            name: "startDate",
                                            placeholder: "Start Date",
                                        },
                                        to: {
                                            name: "endDate",
                                            placeholder: "End Date",
                                        },
                                    },
                                },
                                {
                                    title: "Disco",
                                    name: "disco",
                                    dataType: "select",
                                    options: transformElectricityData,
                                },
                                {
                                    title: "Meter Type",
                                    name: "meterType",
                                    dataType: "select",
                                    options: [
                                        {
                                            display: "Prepaid", payload: "prepaid"
                                        },
                                        {
                                            display: "Postpaid", payload: "postpaid"
                                        }
                                    ]
                                },
                                {
                                    title: "Transaction Status",
                                    name: "status",
                                    dataType: "select",
                                    options: [
                                        {
                                            display: "All",
                                            payload: "",
                                        },
                                        {
                                            display: "Successful",
                                            payload: "successful",
                                        },
                                        {
                                            display: "Pending",
                                            payload: "pending",
                                        },
                                        {
                                            display: "Failed",
                                            payload: "failed",
                                        },
                                    ],
                                },
                            ]}/>
                        </div>

                        <div>
                            <button type="button" onClick={togglePurchaseModal} className="btn btn-ep-primary rounded-lg flex items-center justify-center h-full">
                                <IconAdd width={15} className="mr-2"/>
                                <span>Purchase Electricity</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
                
            <div className="bg-white">

                <Table classTable="table-hover">
                    <Table.Head>
                        <th>Amount</th>
                        <th>Biller</th>
                        <th>Meter Type</th>
                        <th>Meter Number</th>
                        <th>Date</th>
                        <th>Status</th>
                    </Table.Head>
                    <Table.Body>

                        <TableContent
                            loading={loading}
                            loadingText="Fetching Transactions"
                            data={data?.data?.transactions}
                            colspan={5}
                            emptyUI={
                                <TableEmptyData 
                                    actionButtonClicked={togglePurchaseModal}
                                    actionButtonText="Click here to purchase electricity"
                                />
                            }
                        />

                        {loading === false && data?.data?.transactions?.map((transaction) => {
                            return (
                                <tr key={transaction._id} onClick={() => openTransactionDetail(transaction)}>
                                    <td>
                                        {CurrencyFormat(transaction.amount / 100)}
                                    </td>
                                    <td>
                                        <div className="flex items-center capitalize">
                                            
                                            <BillerIcon name={transaction?.product} />
                                            
                                            <span className="ml-2">
                                                {transaction?.product.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
                                            </span>
                                        </div>
                                    </td>
                                    <td className="capitalize">
                                        {transaction?.accountType}
                                    </td>
                                    <td>
                                        {transaction?.account}
                                    </td>
                                    <td>
                                        <div>{DateFormat(transaction.createdAt)} at {TimeFormat(transaction.createdAt)}</div>
                                    </td>
                                    <td>
                                        <div className={"text-xs capitalize label " + renderStatusColor(transaction.status)}>
                                            {transaction.status}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        )}
                    </Table.Body>
                </Table>

                <Maybe condition={loading === false && data?.data?.transactions?.length > 0}>
                    <div className="mt-6">
                        <Pagination data={data?.data} />
                    </div>
                </Maybe>

            </div>
            
        </div>
    )
}

const BillerIcon = ({name}) => {
    const iconWidth = 30;
    
    return (
        <span>
            <Maybe condition={name === 'eko_electric'}>
                <IconEko width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'ikeja_electric'}>
                <IconIkeja width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'ibadan_electric'}>
                <IconIbadan width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'kedco_electric'}>
                <IconKano width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'enugu_electric'}>
                <IconEnugu width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'portharcourt_electric'}>
                <IconPortHC width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'abuja_electric'}>
                <IconAbuja width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'kaduna_electric'}>
                <IconKaduna width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'jos_electric'}>
                <IconJos width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'benin_electric'}>
                <IconBenin width={iconWidth} />
            </Maybe>
            
            <Maybe condition={name === 'aba_electric'}>
                <IconAba width={iconWidth} />
            </Maybe>
        </span>
        
    )
}


const TransactionDetails = ({transaction, setIsOpen, isOpen, ElectricityBillerIcon}) => {
    const transactionAmount = `-${CurrencyFormat(transaction?.amount / 100)}`

    const copyText = () => {
        let content = transaction?.response?.token;
        copy(content);
        toast.success("Copied: " + content);
    }
    

    return (
        <TransactionDetailsWrapper
            title="Debit"
            subtitle="Bill Payment - Electricity"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            amount={transactionAmount}
            status={transaction?.status}
            padFooter={"24px"}
            documentTitle={`Electricity purchase - ${DateFormat(transaction?.createdAt)}`}>
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Transaction Number</div>
                    <div className="text-ep-gray-700">
                        {transaction?.clientReference}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Time Stamp</div>
                    <div className="text-ep-gray-700">
                        {DateFormat(transaction?.createdAt)} at {TimeFormat(transaction?.createdAt)}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Biller</div>
                    <div className="text-ep-gray-700 flex items-center gap-2">
                        <BillerIcon name={transaction?.product} />
                        <span className="uppercase ml-2">{transaction?.product.split('-').map(w => w.toUpperCase()).join(' ')}</span>
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Meter Type</div>
                    <div className="text-ep-gray-700 capitalize">
                        {transaction?.accountType}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Meter Number</div>
                    <div className="text-ep-gray-700">
                        {transaction?.account}
                    </div>
                </div>
                {transaction?.response?.token && <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Meter Token</div>
                    <div className="text-ep-gray-700 flex">
                        {transaction?.response?.token}
                        <span className="inline-block print:hidden"><IconCopy onClick={copyText} className="ml-1" /></span>
                    </div>
                </div>}
        </TransactionDetailsWrapper>
    )
}


export default PowerPurchaseTable;
